import { __assign } from 'tslib';
import * as React from 'react';

/**
 * @description Copy icon component.
 *
 * @component
 * @example
 * ```jsx
 * import { Copy } from '@sravni/design-system-icons'
 *
 * <Copy />
 * ```
 */
var Copy = React.forwardRef(function (props, ref) { return (React.createElement("svg", __assign({ ref: ref, "data-qa": "Copy", viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M15.714 7.857H9.286c-.79 0-1.429.64-1.429 1.429v6.428c0 .79.64 1.429 1.429 1.429h6.428c.79 0 1.429-.64 1.429-1.429V9.286c0-.79-.64-1.429-1.429-1.429Z", stroke: "currentColor", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }),
    React.createElement("path", { d: "M5 12.143h-.714a1.428 1.428 0 0 1-1.429-1.429V4.286a1.429 1.429 0 0 1 1.429-1.429h6.428a1.428 1.428 0 0 1 1.429 1.429V5", stroke: "currentColor", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }))); });

export { Copy };
//# sourceMappingURL=Copy.js.map
